import { SHOP_CONFIG } from "./shop.config";

export const getShopUrl = (): string => {
  const url = (SHOP_CONFIG.shopUrl || "").trim();
  return url;
};

export const isShopEnabled = (): boolean => {
  const url = getShopUrl();
  if (!url) return false;
  try {
    const parsed = new URL(url);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
};

export const openShop = (): void => {
  if (!isShopEnabled()) return;
  window.open(getShopUrl(), "_blank", "noopener,noreferrer");
};
